module.exports = __webpack_public_path__ + "static/img/12.2748a31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/12.png
// module id = 61Wj
// module chunks = 0